import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, Calculator, MessageCircle } from "lucide-react";
export default function CourseIntroduction() {
  return <section id="introducción-al-curso" className="bg-background">
      <div className="bg-foreground relative w-full overflow-hidden py-20 lg:py-32">
        {}
        <div className="absolute top-0 left-1/4 w-1/2 h-1/2 bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
            
            {}
            <div className="lg:col-span-7 flex flex-col items-start">
              <Badge variant="outline" className="border-primary bg-white/5 backdrop-blur-md text-white mb-8 py-2 px-4 text-sm font-medium tracking-wide">
                Certificación Profesional
              </Badge>
              
              <h1 className="font-sans font-extrabold text-5xl sm:text-6xl lg:text-7xl tracking-tight text-white leading-[1.1] mb-6">
                Domina el arte de la <br className="hidden sm:block" />
                <span className="text-secondary">PRESUPUESTACIÓN</span>
              </h1>
              
              <p className="text-lg sm:text-xl text-muted/80 max-w-2xl mb-10 leading-relaxed font-light">
                Aprende a calcular costos con precisión, optimizar recursos y asegurar la rentabilidad de cada proyecto. Una formación intensiva diseñada para profesionales del sector que buscan dar el siguiente paso en su carrera.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                <Button size="lg" className="bg-[#25D366] hover:bg-[#22c35e] text-white font-bold text-base h-14 px-8 rounded-xl border-none shadow-md group" asChild>
                  <Link to="https://wa.me/59896344395" newTab>
                    <MessageCircle className="mr-2 size-5" />
                    Consultar por WhatsApp
                  </Link>
                </Button>
                <Button size="lg" className="bg-[#009EE3] hover:bg-[#008ED2] text-white font-bold text-base h-14 px-8 rounded-xl border-none shadow-md group" asChild>
                  <Link to="https://mpago.la/1WfMEZk" newTab>
                    Pagar con Mercado Pago
                    <ArrowRight className="ml-2 size-5 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </Button>
              </div>
            </div>

            {}
            <div className="lg:col-span-5 relative mt-10 lg:mt-0">
              {}
              <div className="absolute -top-6 -right-6 w-full h-full max-w-[280px] max-h-[280px] bg-[radial-gradient(var(--color-primary)_2px,transparent_2px)] [background-size:20px_20px] opacity-40 z-0 rounded-tr-[32px]" />
              
              {}
              <div className="relative z-10 rounded-[24px] overflow-hidden shadow-2xl shadow-black/50 border border-white/10 bg-card/5 backdrop-blur-sm">
                {}
                <div className="absolute inset-0 bg-primary/20 mix-blend-overlay z-20 pointer-events-none" />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-transparent to-transparent z-20 pointer-events-none" />
                
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/professional_blueprint_review.png" alt="Profesional revisando planos y calculando presupuesto" className="w-full h-auto object-cover aspect-[4/5] sm:aspect-square lg:aspect-[4/5] transform hover:scale-105 transition-transform duration-700 ease-out" />
                
                {}
                <div className="absolute bottom-6 left-6 right-6 z-30 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-4 flex items-center gap-4">
                  <div className="bg-primary/20 p-3 rounded-xl text-primary-foreground">
                    <Calculator className="size-6 text-white" />
                  </div>
                  <div>
                    <p className="text-white font-bold text-sm">Metodología Práctica</p>
                    <p className="text-white/70 text-xs">Casos reales de estudio</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}